export const UPDATE_PSEUDONYM_SUCCESS = 'UPDATE_PSEUDONYM_SUCCESS';

export const updatePseudonymSuccess = ({ pseudonym }) => ({
    type: UPDATE_PSEUDONYM_SUCCESS,
    payload: {
        pseudonym,
    },
});
